<template>
  <div class="transcript-switch">
    <switch-components
      :component-list="componentList"
      :active-component="activeComponent"
      @change-component="changeComponent"
    ></switch-components>

    <transition name="default" mode="out-in">
      <component :is="activeComponent"></component>
    </transition>
  </div>
</template>

<script>
import NProgress from 'nprogress'
import SwitchComponents from '@/components/SwitchComponents.vue'
import TheTranscriptClass from './TheTranscriptClass.vue'
import TheTranscriptClassStudent from './TheTranscriptClassStudent.vue'
import TheTranscriptStudent from './TheTranscriptStudent.vue'

export default {
  // 检测类型
  beforeRouteEnter(to, from, next) {
    if (to.query.type) {
      next()
    } else {
      next({ name: 'transcriptSwitch', query: { type: 'class' } })
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.type) {
      next()
      for (const item of this.componentList) {
        if (item.type === this.$route.query.type) {
          this.activeComponent = item.component
        }
      }
    } else {
      next({ name: 'transcriptSwitch', query: { type: 'class' } })
      NProgress.done()
    }
  },

  components: {
    SwitchComponents,
    TheTranscriptClass,
    TheTranscriptClassStudent,
    TheTranscriptStudent,
  },

  data() {
    return {
      activeComponent: 'the-transcript-student',
      componentList: [
        {
          type: 'class',
          title: 'public.class',
          component: 'the-transcript-class',
          children: ['the-transcript-class-student'],
        },
        {
          hidden: true,
          type: 'classStudent',
          title: 'public.class',
          component: 'the-transcript-class-student',
        },
        {
          type: 'student',
          title: 'public.student',
          component: 'the-transcript-student',
        },
      ],
    }
  },

  created() {
    for (const item of this.componentList) {
      if (item.type === this.$route.query.type) {
        this.activeComponent = item.component
      }
    }
  },

  methods: {
    // 改变路由
    changeComponent(component) {
      let type = ''
      for (const item of this.componentList) {
        if (item.component === component) {
          type = item.type
        }
      }
      // 同一组件，生命周期没有created
      this.$router.push({
        name: this.$route.name,
        query: {
          type: type,
        },
      })
    },
  },
}
</script>

<style lang="less">
@import '../../style/variable.less';

.transcript-switch {
  height: calc(~'100% - @{pageHeaderHeight}');
}
</style>
